import {useEffect,useState} from 'react';
import {doc,onSnapshot} from 'firebase/firestore';
import {db} from '../../Security/firebase-config';
import {notificationContext} from './prefsModel';
export default function useNotificationContext(uid,teamId) {
 const [state,setState]=useState(null);
 useEffect(()=>{
  if(!uid||!teamId)return undefined;
  let alive=true;const values={team:{},subscription:{}};
  const update=()=>{if(alive)setState({uid,teamId,context:notificationContext(uid,values.team,values.subscription)});};
  const stops=[['team',doc(db,'teams',teamId)],['subscription',doc(db,'teams',teamId,'billingV2','subscription')]].map(([key,ref])=>onSnapshot(ref,snap=>{values[key]=snap.data()||{};update();},()=>{values[key]={};update();}));
  return()=>{alive=false;stops.forEach(stop=>stop());};
 },[uid,teamId]);
 return state?.uid===uid&&state?.teamId===teamId?state.context:{personal:true};
}
